import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import TKVantaihanghoathongthuong from "components/Thongke/Vantaihanghoa/Vantaihanghoathongthuong.js";
import TKVantaihanghoacontainer from "components/Thongke/Vantaihanghoa/Vantaihanghoacontainer.js";
export default function TKVantai() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Vận tải hàng hóa thông thường",
            tabContent: <TKVantaihanghoathongthuong />,
          },
          {
            tabName: "Vận tải hàng hóa container",
            tabContent: <TKVantaihanghoacontainer />,
          },
        ]}
      />
    </div>
  );
}
